<template>
  <b-container v-if="this.$root.token" class="pt-2">
    <b-container class="pt-0 pb-0 " v-if="gpcSession">
      <customer-selection ref="customerfield" :customer="gpcSession.customer_id" v-model="gpcSession.customer_id" :noNew="true" v-on:update:customer="gpcSession.customer_id = $event;"/>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="dateOfSessionGroup"
            breakpoint="md"
            label="Date of Session"
            label-for="date"
            validated
          >
            <datepicker v-model="gpcSession.session_date" id="date" :disabledDates="{'from': new Date()}"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="problemOwnerGroup"
            breakpoint="md"
            label="Problem Owner and Title"
            label-for="problemOwner"
            validated
          >
            <b-form-input v-model="gpcSession.responsible_name" type="text" placeholder="Name" id="problemOwner" required/>
            <b-form-input v-model="gpcSession.responsible_role" type="text" placeholder="Title/Role" id="problemOwnerRole" required/> 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="coachGroup"
            breakpoint="md"
            label="Coach"
            label-for="coach"
            validated
          >
            <b-form-select v-model="gpcSession.coach_name" :options="['Jenni Ross-Janett', 'Kelly McLuckie']" class="mb-3" id="coach" required/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="participantsGroup"
            breakpoint="md"
            label="Group Members"
            label-for="participants"
            validated
          >
            <wysiwyg v-model="gpcSession.participants" id="participants" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="problemGroup"
            breakpoint="md"
            label="Problem"
            label-for="problem"
            validated
          >
            <wysiwyg v-model="gpcSession.problem" id="problem"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="actionsGroup"
            breakpoint="md"
            label="Actions"
            label-for="actions"
            validated
          >
            <wysiwyg v-model="gpcSession.actions" id="actions"/>  
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-form-group 
            id="nextStepGroup"
            breakpoint="md"
            label="Next Step"
            label-for="next_step"
            validated
          >
            <wysiwyg v-model="gpcSession.next_step" id="next_step"/>  
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="saving" class="text-center">
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-row>
      <b-alert :show="!!message" variant="success" ref="gpcInputMessage" >{{ message }}</b-alert>
      <b-row class="pb-5" v-if="!saving">
        <b-col>
          <b-button variant="success" @click="save()" :disabled="!formCompleted">Save</b-button>
        </b-col>
        <b-col v-if="!!message" >
          <b-button variant="primary" @click="clearForm()">Add another</b-button>
        </b-col>
        <b-col>
          <b-button variant="default" @click="clearForm()">Clear Form</b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>
<script>
// @ is an alias to /src
import Datepicker from 'vuejs-datepicker';
import CustomerSelection from "@/components/CustomerSelection.vue";
import * as API from '@/services/API';

export default {
  name: "GPCAdd",
  components: {
    Datepicker,
    CustomerSelection
  },
  props: {
    gpcSessionToEdit: {
      type: Object,
      default: function () {
        return {
          id: null,
          session_date: null,
          responsible_name: null,
          responsible_role: null,
          coach_name: null,
          participants: null,
          problem: null,
          actions: null,
          next_step: null,
          customer_id: null
        };
      }
    }
  },
  watch: {
    gpcSessionToEdit: function(newVal) {
      this.init();
    }
  },
  data: function() {
    return {
      saving: false,
      message: null,
      gpcSession: {}
    };
  },
  computed: {
    formCompleted: {
      get: function() {
        if (!this.gpcSession.customer_id) return false;
        // check for nulls
        return Object.keys(this.gpcSession).reduce((accumulator, field) => {
          if (!accumulator || field === 'id') return accumulator;
          if (!this.gpcSession[field]) return false;
          return accumulator;
        }, true);
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.message = '';
      // we might have been given a "full" GPC session
      if (this.gpcSessionToEdit) this.gpcSession = this.gpcSessionToEdit;
      this.gpcSession = {
        id: this.gpcSession.id || null,
        session_date: this.gpcSession.session_date || null,
        responsible_name: this.gpcSession.responsible_name || null,
        responsible_role: this.gpcSession.responsible_role || null,
        coach_name: this.gpcSession.coach_name || null,
        participants: this.gpcSession.participants || null,
        problem: this.gpcSession.problem || null,
        actions: this.gpcSession.actions || null,
        next_step: this.gpcSession.next_step || null,
        customer_id: this.gpcSession.customer_id || (this.gpcSession.customer || {}).id || null
      };
    },
    clearForm() {
      this.gpcSession.session_date = null;
      this.gpcSession.responsible_name = null;
      this.gpcSession.responsible_role = null;
      this.gpcSession.coach_name = null;
      this.gpcSession.participants = null;
      this.gpcSession.problem = null;
      this.gpcSession.actions = null;
      this.gpcSession.next_step = null;
      this.gpcSession.customer_id = null;
      this.gpcSession.id = null;
    },
    save() { 
      this.saving = true;
      this.message = 'Saving....';
      // do actual search
      const body = JSON.parse(JSON.stringify(this.gpcSession));
      delete body.customer_id;
      delete body.id;

      API.saveGPCSession(this.gpcSession.customer_id, this.gpcSession.id, body, this.$root.token).then(results => {
        this.$emit('update-gpc', this.gpcSession);
        this.saving = false;
        this.message = 'Saved!';
        if (!this.gpcSession.id) this.clearForm();
      }).catch(e => {
        this.saving = false;
        this.message = 'DID NOT SAVE - CALL SUPPORT';
      });
      
    }
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/components/GPCAdd.vue